import { css } from "styled-components";

export const fonts = css`
  @import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;700&family=IBM+Plex+Sans:wght@400;700&display=swap");

  * {
    font-family: "IBM Plex Sans", sans-serif;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "IBM Plex Mono", monospace;
  }
`;
